import React from 'react'
import { Absolute } from 'particles'
export default props => <Absolute left right top bottom of='hidden' {...props} />


// WEBPACK FOOTER //
// ./src/core/components/atomic/atoms/BackgroundGradient/index.js